import { ColumnsProps } from 'components/Table/Table'

export const COLUMNS = (): ColumnsProps[] => [
  { fixed: true, name: 'userName', title: 'Usuário' },
  { align: 'right', name: 'url', title: 'URL' },
  { align: 'right', name: 'ip', title: 'IP de Navegação' },
  { name: 'filters', title: 'Pesquisas' },
  { name: 'dateTime', title: 'Data/Hora' }
]
